import { Box, Button, Typography, useTheme } from '@mui/material'
import { useFormikContext } from 'formik'

import {
  EScanToEarnProgressions,
  useScanToEarnContext,
} from '../form-wrapper/scan-to-earn-context.component'
import { IScanToEarnCreateForm } from 'src/types/scan-to-earn.type'
import { MediaInput } from 'src/components/media-input'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { useState } from 'react'
import { SCAN_TO_EARN_FORM_INITIAL } from '../form-wrapper'

export const AddMediaProgression = () => {
  const [isMediaTouched, setIsMediaTouched] = useState(false)

  const theme = useTheme()

  const { progression, setProgression, handleHowDoesItWorkOpen } = useScanToEarnContext()
  const { setFieldValue, values, setValues, errors } = useFormikContext<IScanToEarnCreateForm>()

  const handleBackClick = () => {
    setProgression(EScanToEarnProgressions.CAMERA)
    setValues({ ...SCAN_TO_EARN_FORM_INITIAL, coords: values.coords })
  }

  const handleContinueClick = () => {
    setValues((values) => ({
      ...values,
      company_name: '',
      product_name: '',
      summary: '',
      impacts: [],
      new_impacts: [],
    }))
    setProgression(EScanToEarnProgressions.DETAILS)
  }

  if (progression !== EScanToEarnProgressions.ADD_MEDIA) {
    return null
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          width: '100%',
        }}
      >
        <Typography sx={{ fontSize: '24px', fontWeight: 700 }}>
          <HelperWrapper t="scan-to-earn-add-media-step-header-text" />
        </Typography>

        <Button onClick={handleHowDoesItWorkOpen} variant="text" size="small">
          <HelperWrapper t="scan-to-earn-how-does-this-work-button-label" isColorInherited />
        </Button>

        <Typography sx={{ color: theme.palette.custom.grey2, textAlign: 'center', p: '0 10px' }}>
          <HelperWrapper t="scan-to-earn-add-media-step-secondary-text" />
        </Typography>
        <Typography sx={{ color: theme.palette.custom.grey2, textAlign: 'center', p: '0 10px' }}>
          {`Barcode ID: ${values.barcode_value}`}
        </Typography>
        <Box sx={{ width: '100%', maxWidth: '600px' }}>
          <MediaInput
            // disabled={disabled}
            mainImageSwitch
            inputName="media"
            media={values.media}
            setFieldValue={setFieldValue}
            setIsMediaTouched={setIsMediaTouched}
            scanToEarnMode
            errorText={isMediaTouched && errors.media ? (errors.media as string) : undefined}
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '30px',
          mb: '40px',
        }}
      >
        <Button onClick={handleBackClick} variant="outlined" size="small">
          <HelperWrapper t="scan-to-earn-start-over-button-label" isColorInherited />
        </Button>

        <Button
          disabled={!values.media || values.media.length < 1 || !!errors.media}
          variant="contained"
          size="small"
          onClick={handleContinueClick}
        >
          <HelperWrapper t="scan-to-earn-continue-button-label" isColorInherited />
        </Button>
      </Box>
    </Box>
  )
}
